const NAME = "USER_MENU";

export default NAME;
